export default __webpack_public_path__ + "static/media/vision.6be89ba2.jpg";